import ServicesDetail from "../components/layout/home/our-services/ServicesDetail";

const ServicesDEtailPage = (props) => {
  return <ServicesDetail content1={props.content1} />;
};

export default ServicesDEtailPage;
